import React from 'react';
import classnames from 'classnames';
// utils 
import {translateStatus} from '../../../utils';

const CaseBodyListActions = (props) => {
  let statusIcon = classnames({
    'gdocs-float-left icon icon-circle-error-solid case-in-progress-icon': props.status === 'incomplete',
    'gdocs-float-left icon icon-circle-confirmation-solid no-conflict-icon': props.status === 'complete'
  });
  return(
    <div className='rightContent gdocs-ptop-10'>
      <span className="case-status">
        {translateStatus(props.lang,props.status)}
      </span>
      <div className={statusIcon}></div>
    </div>
  );
}

export default CaseBodyListActions;



// WEBPACK FOOTER //
// ./src/components/common/NavigationList/CaseBodyListActions.js